import {chain} from "../../../../../../../utils/fs";
import {mapValues} from "../../../../../../../utils/objects";
import {cbc} from "../../../../../../../react/callback-chain";

export const convertRecords = ({modification, rows, keys, countryCode}) => {
    const convertRecord = ConvertRecord({countryCode, keys});
    return chain(
        rows,
        (_) => _.map((row, i) => ({
            ...chain(
                modification.replaces.find((r) => r.index === i),
                (replace) => replace ? {
                    address: replace.address,
                    type: "replace",
                } : {
                    address: convertRecord(row),
                },
            ),
            index: i,
        })),
        (_) => _.filter((r) => !modification.deletes.find((d) => d.index === r.index)),
        (_) => [..._, ...modification.adds.map((r) => ({...r, type: "add"}))],
    );
};

const ConvertRecord = ({countryCode, keys}) => {

    const fieldConvertors = {
        state: ConvertState({countryCode}),
    };

    return (row) => (
        mapValues(keys, (index, key) => chain(
            index == null || isNaN(index) ? undefined : row[index],
            // (v) => key === "state" ? ConvertState({countryCode})(v) : v,
            (v) => chain(
                fieldConvertors[key] ?? (v=>v),
                (convertor) => convertor(v),
            ),
        ))
    );
};

const ConvertState = ({countryCode}) => {
    const stateCodes = countryCode === "CA" ? (
        require("../../../../../common/canada-provinces.json")
    ) : (
        require("../../../../../common/us-states.json")
    );

    return (v) => cbc([
        (_, next) => !(v?.trim()) ? v : next(),
        (_, next) => chain(
            stateCodes.find(({abbreviation}) => abbreviation === v),
            (code) => code ? code.abbreviation : next()
        ),
        (_, next) => chain(
            v.toLowerCase().trim(),
            (v) => stateCodes.find(({name, alternativeNames}) => name.toLowerCase() === v || alternativeNames?.find((n) => n.toLowerCase() === v)),
            (code) => code ? code.abbreviation : next()
        ),
        (_) => v,
    ]);
};
